export default (deps = {}) => {
  const windowMock = deps.window || window;

  return 'onpagehide' in windowMock;
};
